import template from './atm-makes.html';
import controller from './atm-makes.controller';

let AtmMakesComponent = {
    bindings: {},
    template,
    controller
};

export default AtmMakesComponent;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/atm-makes/atm-makes.component.js